import { render, staticRenderFns } from "./PatientIntroduction.vue?vue&type=template&id=44966e08&scoped=true&"
import script from "./PatientIntroduction.vue?vue&type=script&lang=js&"
export * from "./PatientIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./PatientIntroduction.vue?vue&type=style&index=0&id=44966e08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44966e08",
  null
  
)

export default component.exports